import useFeatureFlags from "../hooks/useFeatureFlag";
import { WebTracker } from "./types";

export type wtmURLs = {
  phiAllowlist: string | undefined;
  trackersOverview: string;
  trackerBlocking: string;
  trackerDetailTpl: string;
  urlForTrackerDetail(tracker: WebTracker): string;
};

export default function useWTMURLs(): wtmURLs {
  const flag = useFeatureFlags();

  if (flag("unifiedDestinationsUI")) {
    return {
      phiAllowlist: "/monitoring/phiAllowlist",
      trackersOverview: "/monitoring/trackingTools",
      trackerBlocking: "/monitoring/trackerBlocking",
      trackerDetailTpl: "/monitoring/trackingTools/:trackerId",
      urlForTrackerDetail(tracker: WebTracker) {
        return `/monitoring/trackingTools/${tracker.name}`;
      },
    };
  }

  return {
    phiAllowlist: undefined,
    trackersOverview: "/trackers",
    trackerBlocking: "/trackers/trackerBlocking",
    trackerDetailTpl: "/trackers/:trackerId",
    urlForTrackerDetail(tracker: WebTracker) {
      return `/trackers/${tracker.name}`;
    },
  };
}
